import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Kristusove gate",
  "description": "",
  "published": "2006-07-31T00:00:00.000Z",
  "redirect_from": ["/blog/kristusove-gate/swizec/393"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/sneeks/3_1.jpg",
        "alt": null
      }}></img></p>
    <p>{`Koledar pravi, da je konec mesca tu in Äeprav koledarju ne gre verjeti kar vsega, kar tako tja v en dan govori, bi se lahko reklo, da je pri stvareh za katere je bil namenjen kar zanesljiv. VeÄji problem kot konec meseca bi lahko bil, da strip še ni konÄan. Ideja stripa je, da naj bi bil Äimbolj kvaliteten, kvantiteta pa potem seveda trpi. Zgodilo se je paÄ, da je mesec bil kar poln raznoraznih neumnosti in tako je potem kvantiteta zelo trpela.`}<br parentName="p"></br>{`
`}{`Strip bo konÄan do konca tedna potem pa se bo imenoval Avgustovski strip. To seveda zdaj zgleda kot pokvarjen trik, udarec pod pasom, vendar ni. To se bo tako zgodilo zaradi tega, da dobim potreben luft v mesecu; omogoÄilo bo, da se dela na stripih za naslednji mesec. Se pravi, še vedno se muÄim cel mesec kot sedaj, vendar potem nov strip pride na zaÄetku meseca namesto na koncu. Super kaj?`}</p>
    <p>{`Nekateri ste morda tudi opazili da spletna kamera na levi na opravlja svojih dolÅ¾nosti kot bi jih morala. No bila je temeljito izprašana in bo morala odgovarjati za svoja dejanja oz. v tem primeru nedejanja. Po dolgem muÄenju se je mehanizem zlomil in priznal, da ima del, ki nalaga slike na server probleme z nekimi socketi in paÄ ne gre nalagati. V to bom seveda ob priliki pogledal in skušal popraviti... do takrat pa se vidi kar se vidi.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      